module.exports = __webpack_public_path__ + "download/img/drug.517d9b95.png";